/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { AddIcon, CloseIcon, DollarIcon } from 'assets/icons';
import { Input, Select } from 'components';
import { classes, Globals } from 'utils';
import { GeneralService, PlansService } from 'services';
import { WhiteImage2 } from 'assets/img';

const colors = [
  { value: 'light', label: 'Claro' },
  { value: 'dark', label: 'Oscuro' },
];

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

type TypeProps = {
  type_id: string
}

type SpecialtyProps = {
  specialty_id: string
  uses_quantity: string
}

type FormProps = {
  id?: number
  image?: File
  image_url?: string
  color: string
  name: string
  price_monthly: string
  price_quarterly: string
  price_semiannual: string
  price_annual: string
  hasFile: boolean
  specialty_id: string
  specialty_qty: string
  specialty_all: boolean
}

interface ModalEditPlanProps {
  plan?: any
  onClose: (reload?: boolean) => void
}

const ModalEditPlan = ({ plan, onClose }: ModalEditPlanProps) => {
  const { addSpecialty, form, isAllSelected, isEditing, onChange, onChangeSpecialty, removeSpecialty, selectedSpecialties, selectedTypes, specialties, toggleType, types, unselectedSpecialties, validateForm } = useForm(onClose, plan);
  const allSelected = form.specialty_all || isAllSelected;

  return (
    <form onSubmit={validateForm}>
      <header>
        <p className="title">{ isEditing ? 'Editar' : 'Crear' } Plan</p>
        <button type="button" className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <section className="head">
        <div style={{ flex: 1 }}>
          <label className="user-photo">
            {form.image_url ? (
              <img src={form.image_url} alt="Imagen" />
            ) : (
              <img className="user-icon" src={WhiteImage2} alt="Imagen" />
            )}
            <input
              hidden
              type="file"
              accept="image/*"
              onChange={e => {
                if (!e.target?.files?.length) return;
                onChange(e.target.files[0], 'image');
                e.target.value = '';
              }}
            />
          </label>

          <label>Icono del plan</label>
        </div>

        <div style={{ flex: 1 }}>
          <label style={{ marginTop: 0 }}>Color</label>
          <Select
            name="color"
            value={form.color}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'color')}
            options={colors}
          />
        </div>
      </section>

      <section className="body">
        <Input
          label="Nombre del plan"
          value={form.name}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'name')}
        />

        <p className="section-title">Consultas</p>
        <p className="section-subtitle">Seleccione el tipo de consulta que quiere en el plan (debe elegir uno o ambas consultas).</p>

        <label>Tipo de consultas</label>
        {types.map((type, index) => {
          const isSelected = selectedTypes.some((x: any) => x.type_id === type.value);
          return (
            <div
              key={index}
              className="check-item bordered"
              onClick={() => toggleType(type)}
            >
              <div className={classes('checkbox', isSelected ? 'checked' : '')} />
              <span>{ type?.label }</span>
            </div>
          )
        })}

        <p className="section-title">Lista de Especialidades</p>
        <p className="section-subtitle">Elija las especialidades y la cantidad de uso de cada una.</p>

        <label>Tipo de consultas</label>
        <div className="specialties-row">
          <div className="check-item" onClick={() => onChange(!allSelected, 'specialty_all')}>
            <div className={classes('checkbox', allSelected ? 'checked' : '')} />
            <p>Todas</p>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button className="btn-add" type="button" onClick={addSpecialty}>
              <img src={AddIcon} alt="Añadir" />
              <span>Añadir</span>
            </button>
          </div>
        </div>

        <div className="specialties-row">
          <Select
            name="specialty_id"
            placeholder="Especialidad"
            value={form.specialty_id}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'specialty_id')}
            options={unselectedSpecialties}
          />

          <Input
            type="number"
            placeholder="Cantidad"
            value={form.specialty_qty}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'specialty_qty')}
          />
        </div>

        {selectedSpecialties.map((item, index) => (
          <div className="specialties-row" key={index}>
            <div className="specialty-row">
              <button type="button" className="btn-remove" onClick={() => removeSpecialty(index)}>
                <img src={CloseIcon} alt="Eliminar" />
              </button>

              <Select
                name="specialty_id"
                placeholder="Especialidad"
                value={item.specialty_id}
                onChange={(e: IonChangeEvent) => onChangeSpecialty(e.target.value, 'specialty_id', index)}
                options={specialties}
                disabled
              />
            </div>

            <Input
              type="number"
              placeholder="Cantidad"
              value={item.uses_quantity}
              onChange={(e: IonChangeEvent) => onChangeSpecialty(e.target.value, 'uses_quantity', index)}
            />
          </div>
        ))}

        <div className="prices">
          <div>
            <p className="section-title">Costo del plan ($) (Anual)</p>
            <Input
              className="price"
              type="decimal-price"
              searchLeft
              searchIcon={DollarIcon}
              placeholder="00"
              value={form.price_annual}
              onChange={(e: IonChangeEvent) => onChange(e.target.value, 'price_annual')}
            />
          </div>

          <div>
            <p className="section-title">Costo del plan ($) (Semestral)</p>
            <Input
              className="price"
              type="decimal-price"
              searchLeft
              searchIcon={DollarIcon}
              placeholder="00"
              value={form.price_semiannual}
              onChange={(e: IonChangeEvent) => onChange(e.target.value, 'price_semiannual')}
            />
          </div>

          <div>
            <p className="section-title">Costo del plan ($) (Trimestral)</p>
            <Input
              className="price"
              type="decimal-price"
              searchLeft
              searchIcon={DollarIcon}
              placeholder="00"
              value={form.price_quarterly}
              onChange={(e: IonChangeEvent) => onChange(e.target.value, 'price_quarterly')}
            />
          </div>

          <div>
            <p className="section-title">Costo del plan ($) (Mensual)</p>
            <Input
              className="price"
              type="decimal-price"
              searchLeft
              searchIcon={DollarIcon}
              placeholder="00"
              value={form.price_monthly}
              onChange={(e: IonChangeEvent) => onChange(e.target.value, 'price_monthly')}
            />
          </div>
        </div>
      </section>

      <div className="actions">
        <button>Guardar</button>
      </div>
    </form>
  );
}

const useForm = (onClose: (reload?: boolean) => void, plan?: any) => {
  const isEditing = !!plan;
  const [types, setTypes] = useState<any[]>([]);
  const [specialties, setSpecialties] = useState<any[]>([]);
  const [selectedSpecialties, setSelectedSpecialties] = useState<SpecialtyProps[]>([]);
  const [selectedTypes, setSelectedTypes] = useState<TypeProps[]>([]);
  const [form, setForm] = useState<FormProps>({
    name: '',
    color: '',
    price_monthly: '',
    price_quarterly: '',
    price_semiannual: '',
    price_annual: '',
    hasFile: true,
    specialty_id: '',
    specialty_qty: '',
    specialty_all: false,
  });

  const unselectedSpecialties = useMemo(() => {
    const selected = selectedSpecialties.map((x: any) => x.specialty_id);
    return specialties.filter((x: any) => !selected.includes(x.value));
  }, [selectedSpecialties, specialties]);

  const isAllSelected = useMemo(() => {
    return !unselectedSpecialties.length && specialties.length > 0;
  }, [unselectedSpecialties]);

  const getSelects = () => {
    Promise.all([
      GeneralService.getSpecialties(),
      GeneralService.getAppointmentTypes(),
    ])
      .then((res: any[]) => {
        setSpecialties(res[0].map((x: any) => ({ value: String(x.id), label: x.name })) ?? []);
        setTypes(res[1].map((x: any) => ({ value: String(x.id), label: x.name })) ?? []);
      })
      .catch(console.log);
  }

  const onChange = <K extends keyof FormProps>(value: FormProps[K], target: K) => {
    setForm(s => ({ ...s, [target]: value }));

    if (target === 'image' && typeof value === 'object') {
      setForm(s => ({ ...s, image_url: URL.createObjectURL(value) }));
    }
  }

  const toggleType = (item: any) => {
    setSelectedTypes(s => {
      const items = Globals.clone(s);
      const index = items.findIndex((x: any) => x.type_id === item.value);

      if (index === -1) {
        return [ ...items, { type_id: item.value } ];
      }

      items.splice(index, 1);
      return items;
    });
  }

  const addAllSpecialties = () => {
    const items = unselectedSpecialties.map((x: any) => ({
      specialty_id: x.value,
      uses_quantity: '0',
      is_unlimited: 0,
    }));

    setSelectedSpecialties([...selectedSpecialties, ...items]);
    onChange(false, 'specialty_all');
  }

  const addSpecialty = () => {
    if (form.specialty_all) return addAllSpecialties();
    if (!form.specialty_id) return Globals.showError('Debe seleccionar una especialidad');
    if (!form.specialty_qty) return Globals.showError('Debe indicar la cantidad');

    const item = {
      specialty_id: form.specialty_id,
      uses_quantity: form.specialty_qty || '0',
      is_unlimited: 0,
    };

    setSelectedSpecialties([...selectedSpecialties, item]);
    onChange('', 'specialty_id');
    onChange('', 'specialty_qty');
  }

  const removeSpecialty = (index: number) => {
    setSelectedSpecialties(selectedSpecialties.filter((_, i) => i !== index));
  }

  const onChangeSpecialty = <K extends keyof SpecialtyProps>(value: SpecialtyProps[K], target: K, index: number) => {
    setSelectedSpecialties(s => {
      const items = Globals.clone(s);
      items[index] = { ...items[index], [target]: value };
      return items;
    });
  }

  const validateForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!form.image_url)
      return Globals.showError('Debe ingresar el icono');

    if (!form.color)
      return Globals.showError('Debe ingresar el color');

    if (!form.name)
      return Globals.showError('Debe ingresar el nombre');

    if (!selectedTypes.length)
      return Globals.showError('Debe seleccionar al menos un tipo de consulta');

    if (!selectedSpecialties.length && form.specialty_all)
      return Globals.showError('Debe presionar el botón "Añadir" para agregar todas a la lista');

    if (form.specialty_id && form.specialty_qty)
      return Globals.showError('Debe presionar el botón "Añadir" para agregar la especialidad a la lista');

    if (!selectedSpecialties.length)
      return Globals.showError('Debe seleccionar al menos una especialidad');

    if (selectedSpecialties.some(x => !Number(x.uses_quantity)))
      return Globals.showError('Debe indicar la cantidad de todas las especialidades');

    if (!Number(form.price_annual))
      return Globals.showError('Debe ingresar el precio anual');

    if (!Number(form.price_semiannual))
      return Globals.showError('Debe ingresar el precio semestral');

    if (!Number(form.price_quarterly))
      return Globals.showError('Debe ingresar el precio trimestral');

    if (!Number(form.price_monthly))
      return Globals.showError('Debe ingresar el precio mensual');

    onSubmit();
  }

  const onSubmit = async () => {
    const data = {
      ...form,
      types: JSON.stringify(selectedTypes.map((x: any) => ({
        type_id: x.type_id,
      }))),
      specialties: JSON.stringify(selectedSpecialties.map((x: any) => ({
        specialty_id: x.specialty_id,
        uses_quantity: x.uses_quantity,
        is_unlimited: parseInt(x.is_unlimited),
      }))),
    }

    try {
      if (isEditing) {
        await PlansService.update(data);
        Globals.showSuccess('Plan actualizado');

      } else {
        await PlansService.create(data);
        Globals.showSuccess('Plan creado con éxito');
      }
      onClose(true);

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getSelects();
    if (!plan) return;

    setForm({
      id: plan?.id,
      image: undefined,
      image_url: plan?.image ? Globals.fromPhotos(plan?.image) : undefined,
      color: plan?.color,
      name: plan?.name,
      specialty_id: '',
      specialty_qty: '',
      specialty_all: false,
      price_monthly: String(plan?.price_monthly),
      price_quarterly: String(plan?.price_quarterly),
      price_semiannual: String(plan?.price_semiannual),
      price_annual: String(plan?.price_annual),
      hasFile: true,
    });

    setSelectedTypes(plan?.types?.map((x: any) => ({
      type_id: String(x.type_id),
    })) || []);

    setSelectedSpecialties(plan?.specialties?.map((x: any) => ({
      specialty_id: String(x.specialty_id),
      uses_quantity: x.uses_quantity,
      is_unlimited: x.is_unlimited,
    })) || []);
  }, []);

  return {
    addAllSpecialties,
    addSpecialty,
    form,
    isAllSelected,
    isEditing,
    onChange,
    onChangeSpecialty,
    removeSpecialty,
    selectedSpecialties,
    selectedTypes,
    specialties,
    toggleType,
    types,
    unselectedSpecialties,
    validateForm,
  }
}

export default ModalEditPlan;